var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Icon from '../../../components/Icon';
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import translate from '../../../lib/utils/translate';

var AmountItemContent = function (_Component) {
  _inherits(AmountItemContent, _Component);

  function AmountItemContent(props) {
    _classCallCheck(this, AmountItemContent);

    return _possibleConstructorReturn(this, (AmountItemContent.__proto__ || Object.getPrototypeOf(AmountItemContent)).call(this, props));
  }

  _createClass(AmountItemContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          _props$config = _props.config,
          config = _props$config === undefined ? [] : _props$config,
          type = _props.type,
          timespan = _props.timespan,
          amount = _props.amount,
          handleLimitAmount = _props.handleLimitAmount,
          handleLimitTimespan = _props.handleLimitTimespan,
          handleIncrement = _props.handleIncrement,
          handleDecrement = _props.handleDecrement,
          activeLimit = _props.activeLimit,
          submitButton = _props.submitButton,
          currency = _props.currency;


      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'limit-container' },
          React.createElement(
            'div',
            { className: 'timespan-selector' },
            config.map(function (item) {
              return React.createElement(
                'button',
                {
                  onClick: function onClick() {
                    handleLimitTimespan(item);
                  },
                  value: timespan,
                  type: 'button',
                  name: 'Timespan',
                  className: 'button primary' + (timespan === item.value ? ' selected' : ''),
                  key: item.value },
                translate({ id: item.label }, intl)
              );
            })
          ),
          React.createElement(
            'div',
            { className: 'custom-amount' },
            React.createElement(Input, { value: type, name: 'Type', type: 'hidden' }),
            React.createElement(
              'div',
              { className: 'custom-amount-decrement', onClick: handleDecrement },
              React.createElement(Icon, { icon: 'minus' })
            ),
            React.createElement(Input, {
              className: 'custom-amount-input',
              onChange: handleLimitAmount,
              name: 'Amount',
              type: 'number',
              min: '1',
              max: '99999999',
              value: amount || '',
              placeholder: timespan && !activeLimit ? translate({
                id: 'label.no-limit-set',
                defaultMessage: 'No limit'
              }, intl) : null,
              currency: currency,
              inputMode: 'numeric',
              pattern: '[0-9]*'
            }),
            React.createElement(
              'div',
              { className: 'custom-amount-increment', onClick: handleIncrement },
              React.createElement(Icon, { icon: 'plus' })
            )
          ),
          React.createElement(
            Button,
            { className: 'button primary wide', disabled: !submitButton },
            translate({
              id: 'action.button.set-limit',
              defaultMessage: 'Set limit'
            }, intl)
          )
        )
      );
    }
  }]);

  return AmountItemContent;
}(Component);

export default injectIntl(AmountItemContent);